import * as R from 'ramda';

export const getUpdatedIds = (state, ids, polling) => {
  if (polling) return ids;
  if (R.isNil(ids)) return state.ids;
  return R.union(state.ids, ids);
};



// WEBPACK FOOTER //
// ./src/redux/reducers/helpers.js